<ng-container *ngIf="questionnaireTrack == 0; else chatView">
<div class="strategies-info upload-client h-100 d-flex flex-column">

  <!-- Summary -->
  <div class="d-flex flex-column mb-3 panel-main-title">
    <label>Top Tax Strategies Identified</label>
  </div>

  <div class="text-muted mb-3 d-flex align-items-center gap-3 rap-questionnarie-strategies-detail">
    <img src="/images/jaine-bot.png" alt="AI Avatar" class="summary_icon" /> 
    <div>
      <p class="text-dark mb-2">
        jAIne here! I found {{
        aiSuggestedStrategies?.length || 0 }} suggested tax strategies based on the 1040 you uploaded.
        If you’d like, I can ask some questions to look for additional opportunities that don’t always show up on the tax
        return.</p>
        <p class="text-dark mb-0"> Here’s a preview of the
          <ng-container *ngIf="(aiSuggestedStrategies?.length || 0) >= 5; else lessThanFive">
            <strong class="text-dark">Top 5</strong>
          </ng-container>
          <ng-template #lessThanFive>
            <strong class="text-dark">Top {{ aiSuggestedStrategies?.length || 0 }}</strong>
          </ng-template>
          strategies, representing the highest estimated tax savings I can see from the return alone.
        </p>
    </div>
  </div>
 

  <!-- Strategy List -->
  <div class="strategy-list flex-fill overflow-auto">
    <!-- Header Row -->
    <div class="strategy-list-header d-flex justify-content-between align-items-center px-3 py-2">
      <span class="fw-bold">Tax Strategy</span>
      <span class="fw-bold">Est. Tax Savings</span>
    </div>
    <mat-accordion>
      <mat-expansion-panel class="strategy-info-box"
        *ngFor="let item of aiSuggestedStrategies | slice:0:5; let i = index" [expanded]="false">

        <mat-expansion-panel-header>
          <mat-panel-title class="d-flex align-items-center gap-2">
            <span class="strategy-index">{{ i + 1 }}</span>
            <span class="strategy-name d-flex flex-grow-1 justify-content-between align-items-center gap-3">
              {{ item.name }} 
              <span>{{item.totalSavings}}</span>
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Description -->
        <div class="strategy-desc" [innerHTML]="item.description"></div>

      </mat-expansion-panel>
    </mat-accordion>

  </div>

  <div class="explore-text-box mt-4">
  <p class="text-dark mb-1">Would you like to explore a few more ideas, or
    move ahead with selecting from these {{ aiSuggestedStrategies?.length || 0 }} strategies for your proposal?</p>

    <div class="mt-2 d-flex justify-content-start align-items-center gap-3 flex-wrap">
      <button class="button d-flex gap-3 align-items-center mb-0 position-relative" data-testid="discovery-intro-find-more" (click)="showAiQuestionnarieSection()">
        <span class="ribbon-wrapper">
          <span class="ribbon">Beta</span>
        </span>
        <!-- <mat-icon>search</mat-icon> -->
         <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
          <path d="M13.75 23.75C19.2728 23.75 23.75 19.2728 23.75 13.75C23.75 8.22715 19.2728 3.75 13.75 3.75C8.22715 3.75 3.75 8.22715 3.75 13.75C3.75 19.2728 8.22715 23.75 13.75 23.75Z" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M26.25 26.25L20.8125 20.8125" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="d-flex flex-column gap-1 text-start">Let's Find More
        <small>Answer a few questions with jAIne (2-4 minutes)</small></span>
      </button>

      <button class="button d-flex gap-3 align-items-center mb-0" data-testid="discovery-intro-skip" (click)="goToNextSection('skip-questionnarie-strategiesInfo')">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
          <rect x="1" y="1" width="26" height="26" rx="13" stroke="white" stroke-width="2"/>
          <path d="M19 10.25L12.125 17.125L9 14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="d-flex flex-column gap-1 text-start">Skip and Review Current Strategies
          <small>Review and select strategies for your proposal</small>
        </span>
      </button>
    </div>
  </div>

  <div class="mt-3 text-muted small">
    <p class="mb-0 d-flex gap-2 align-items-center small-text">
      Recommendations assume prior-year facts continue unless updated. If fewer than 5 strategies populate, this may be
      due to unclear or incomplete data in the uploaded return. You can upload a clearer copy of the prior-year 1040 for
      reprocessing or submit a bug request through the Help Hub.
    </p>
  </div>

</div>
</ng-container>
<ng-template #chatView>
<div class="chat-container">
  <div class="messages" #messagesContainer>
    <div *ngFor="let msg of messages; let i = index" [ngClass]="msg.sender" class="message-row"
      [ngStyle]="msg.sender === 'ai' && msg.text !== '' && i === messages.length - 1 ? { minHeight: 'calc(760px - 315px)' } : {}">
      <ng-container *ngIf="msg.sender === 'ai' && msg.text !== ''">
        <img src="/images/jaine-bot.png" alt="AI Avatar" class="ai_icon" />
        <div class="bubble">
          <markdown [data]="msg.text"></markdown>
          <div *ngIf="msg.messageId" class="rating-actions">
            <button class="rating-btn" (click)="onCopyMessage(i)">
              <mat-icon>content_copy</mat-icon>
              {{ copiedIndex === i ? 'Copied' : 'Copy' }}
            </button>

            <button class="rating-btn" [class.liked]="msg.userRating === 1" (click)="rateMessage(i, 1)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/>
                <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" fill="none" stroke="currentColor" stroke-width="2"/>
              </svg>
              {{ msg.userRating === 1 ? 'Liked' : 'Like' }}
            </button>

            <button class="rating-btn" [class.disliked]="msg.userRating === -1" (click)="rateMessage(i, -1)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3H10z"/>
                <path d="M17 2h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" fill="none" stroke="currentColor" stroke-width="2"/>
              </svg>
              {{ msg.userRating === -1 ? 'Disliked' : 'Dislike' }}
            </button>
          </div>

          <div *ngIf="feedbackIndex === i" class="feedback-panel">
            <div class="feedback-header">
              <span>Why is this a bad response?</span>
              <button class="feedback-close" (click)="closeFeedback()">&#x2715;</button>
            </div>
            <div class="feedback-body feedback-input-area">
              <input type="text" class="feedback-input" placeholder="Provide Feedback" [(ngModel)]="feedbackText" (keyup.enter)="submitFeedback(i)" />
              <button class="feedback-submit" (click)="submitFeedback(i)">Submit</button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="msg.sender === 'user'">
        <div class="bubble">{{ msg.text }}</div>
        <div class="user-icon">{{ getUserInitials() }}</div>
      </ng-container>
    </div>
    <!-- SHOW LOADING GIF BEFORE STREAM STARTS -->
    <div *ngIf="isLoading" class="message-row ai" [ngStyle]="{ minHeight: 'calc(760px - 315px)' }">
      <img class="loading-img" src="/images/loading.gif" alt="loading..." />
    </div>
  </div>

  <div class="input-area align-items-start">
    <mat-form-field class="message-box" appearance="outline">
      <textarea #chatInput matInput placeholder="Type your message..." data-testid="discovery-chat-input" [(ngModel)]="userInput"
        (keyup.enter)="sendPrompt()" [disabled]="isStreaming" rows="1"></textarea>
    </mat-form-field>

    <button mat-icon-button color="primary" (click)="sendPrompt()" [disabled]="isStreaming || !userInput.trim()"
      data-testid="discovery-chat-send" class="send-btn">
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
  <div class="mt-0 d-flex justify-content-center align-items-center gap-3 flex-wrap">
  <button class="button btn-sm small" data-testid="discovery-chat-cancel" (click)="showTopStrategiesView()">
    Cancel & Exit Discovery
  </button>

  <button class="button btn-sm small" data-testid="discovery-chat-restart" (click)="restartQuestionnaire()">
    Restart Discovery
  </button>
</div>
</div>
<div class="text-muted small">
    <p class="mb-0 d-flex gap-2 align-items-center">jAIne is AI and can make mistakes. Please double-check responses.</p>
    <p class="mb-0 d-flex gap-2 align-items-center">All questions are optional. Click the Next button to see additional tax strategy suggestions based on your answers.</p>
</div>
</ng-template>
